module.exports = __webpack_public_path__ + "img/support.0f57b086.svg";